import { render, staticRenderFns } from "./areaDetail.vue?vue&type=template&id=f9463c32&scoped=true&"
import script from "./areaDetail.vue?vue&type=script&lang=js&"
export * from "./areaDetail.vue?vue&type=script&lang=js&"
import style0 from "./areaDetail.vue?vue&type=style&index=0&id=f9463c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9463c32",
  null
  
)

export default component.exports